import { api } from './client.js';
import type { SessionUser } from './types.js';

export const authApi = {
  login: (userid: string, password: string) =>
    api.post<{ user: SessionUser }>('/auth/login', { userid, password }),
  logout: () => api.post<void>('/auth/logout'),
  me: () => api.get<{ user: SessionUser }>('/auth/me'),
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post<{ user: SessionUser }>('/auth/change-password', { currentPassword, newPassword }),
};
